import React from "react";

import TermsOfServicePage from "@/pages/Terms/TermsPage";

export default function Layout(): React.JSX.Element {
  return <TermsOfServicePage />;
}
